var map = {
	"./inventory/inventory.vue": "b4bc",
	"./login/login.vue": "a86a",
	"./lost-found/lost-found.vue": "a2c2",
	"./style-guide/style-guide.vue": "5401",
	"./todos/todos.vue": "2a52"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "705d";